'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const styleEncapsulation = require('@zapier/style-encapsulation');
const components_display_Icon_Icon = require('../../display/Icon/Icon.cjs.js');
const theme_Colors = require('../../../theme/Colors.cjs.js');
require('../../../theme/Shadows.cjs.js');
require('../../../theme/Typography.cjs.js');
const theme_LegacyTypography = require('../../../theme/LegacyTypography.cjs.js');
require('react');
const components_patterns_ServiceIcon_ServiceIcon = require('../../patterns/ServiceIcon/ServiceIcon.cjs.js');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');

const Styles = styleEncapsulation.labelStyles("ZapCardSteps", {
  root: react.css`
    ${styleMixins_reset.boxSizing};
    border: 1px solid ${theme_Colors.Colors.GrayWarm3};
    border-radius: 10px;
  `,
  step: react.css`
    ${styleMixins_reset.boxSizing};
    position: relative;
    display: grid;
    grid-template-columns: max-content 1fr;
    gap: 10px;
    align-items: center;
    padding: 10px;
    ${theme_LegacyTypography.LegacyTypography.smallPrint3};
    color: ${theme_Colors.Colors.GrayWarm9};
  `,
  stepName: react.css`
    ${styleMixins_reset.boxSizing};
    ${theme_LegacyTypography.LegacyTypography.smallPrint1Semibold};
    color: ${theme_Colors.Colors.GrayWarm10};
  `,
  divider: react.css`
    ${styleMixins_reset.boxSizing};
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    transform: translateY(-50%);
    display: flex;
    align-items: center;

    &::before,
    &::after {
      content: '';
      height: 1px;
      background-color: ${theme_Colors.Colors.GrayWarm3};
      flex: 1;
    }

    &::before {
      margin-right: 2px;
    }

    &::after {
      margin-left: 2px;
    }
  `
});
const ZapCardStep = (props) => {
  const isTrigger = props.index === 0;
  const divider = !isTrigger && react.jsx(
    "div",
    { css: Styles.divider, "data-zds": true },
    react.jsx(components_display_Icon_Icon.Icon, { color: "GrayWarm2", name: "formAddCircle", size: 18 })
  );
  return react.jsx(
    "li",
    { css: Styles.step, "data-zds": true },
    divider,
    react.jsx(components_patterns_ServiceIcon_ServiceIcon.ServiceIcon, { "aria-hidden": true, serviceName: props.name, size: "medium", src: props.icon }),
    react.jsx(
      "div",
      { "data-zds": true },
      react.jsx("p", { "data-zds": true }, isTrigger ? "When this happens" : "Then do this"),
      react.jsx(
        "p",
        { css: Styles.stepName, "data-zds": true },
        "Step ",
        props.index + 1,
        ": ",
        props.label
      )
    )
  );
};
const ZapCardSteps = (props) => {
  return react.jsx("ol", { css: Styles.root }, props.steps.map((step, i) => {
    return react.jsx(ZapCardStep, Object.assign({}, step, { index: i, key: i }));
  }));
};

exports.ZapCardSteps = ZapCardSteps;
//# sourceMappingURL=ZapCardSteps.cjs.js.map
